import React, { useContext } from 'react';
import { TranslationContext } from "../Context";

function Article(props) {

    const translation = useContext(TranslationContext);
    const replacedByList = () => props.replacedByArticles.map(x => x.articleNumber).join(',');

    return (
        <div className="vehicleProductListComponent-article">
            <div className="vehicleProductListComponent-articlePre u-textRegular14">{translation["TecAlliencePartSearch.ProductList.ItemList.Article"]}</div>
            <div className="vehicleProductListComponent-articleName u-textSemi24">{props.articleNumber}</div>
            {props.replacedByArticles && props.replacedByArticles.length > 0 && <div className="vehicleProductListComponent-articleReplacedBy u-textRegular14">{translation["TecAlliencePartSearch.ProductList.ItemList.ReplacedBy"]}: {replacedByList()}</div>}
        </div>
    );

}
export default Article;